module.exports = {
	"1.01": [
		{
			"code": "2660",
			"aliq": "2.90",
			"service_description": "Análise e desenvolvimento de sistemas"
		}
	],
	"1.02": [
		{
			"code": "2668",
			"aliq": "2.90",
			"service_description": "Programação"
		}
	],
	"1.03": [
		{
			"code": "2684",
			"aliq": "2.90",
			"service_description": "Processamento de dados e congêneres"
		}
	],
	"1.04": [
		{
			"code": "2692",
			"aliq": "2.90",
			"service_description": "Elaboração de programas de computadores (software), inclusive de jogos eletrônicos"
		}
	],
	"1.05": [
		{
			"code": "2800",
			"aliq": "2.90",
			"service_description": "Licenciamento ou cessão de direito de uso de programas de computação, inclusive distribuição"
		}
	],
	"1.06": [
		{
			"code": "2881",
			"aliq": "2.90",
			"service_description": "Assessoria e consultoria em informática"
		}
	],
	"1.07": [
		{
			"code": "2919",
			"aliq": "2.90",
			"service_description": "Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados"
		}
	],
	"1.08": [
		{
			"code": "2935",
			"aliq": "2.90",
			"service_description": "Planejamento, confecção, manutenção e atualização de páginas eletrônicas"
		}
	],
	"1.09": [
		{
			"code": "2961",
			"aliq": "2.90",
			"service_description": "Disponibilização, sem cessão definitiva, de conteúdos de imagem e texto por meio da internet, respeitada a imunidade de livros, jornais e periódicos (exceto a distribuição de conteúdos pelas prestadoras de Serviço de Acesso Condicionado, de que trata a Lei Federal nº 12.485, de 12 de setembro de 2011, sujeita ao ICMS)"
		}
	],
	"2.01": [
		{
			"code": "3085",
			"aliq": "2.00",
			"service_description": "Serviços de pesquisas e desenvolvimento de qualquer natureza"
		}
	],
	"3.02": [
		{
			"code": "7765",
			"aliq": "5.00",
			"service_description": "Cessão de direito de uso de marcas e de sinais de propaganda"
		}
	],
	"3.03": [
		{
			"code": "7773",
			"aliq": "5.00",
			"service_description": "Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, ginásios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza"
		}
	],
	"3.04": [
		{
			"code": "7790",
			"aliq": "5.00",
			"service_description": "Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza"
		}
	],
	"3.05": [
		{
			"code": "7803",
			"aliq": "5.00",
			"service_description": "Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário"
		}
	],
	"4.01": [
		{
			"code": "4111",
			"aliq": "SUP",
			"service_description": "Medicina e biomedicina (regime especial – sociedade)"
		}
	],
	"4.02": [
		{
			"code": "5576",
			"aliq": "2.00",
			"service_description": "Patologia e eletricidade médica"
		}
	],
	"4.03": [
		{
			"code": "4235",
			"aliq": "2.00",
			"service_description": "Casas de saúde, manicômios e congêneres"
		}
	],
	"4.04": [
		{
			"code": "4251",
			"aliq": "2.00",
			"service_description": "Instrumentação cirúrgica"
		}
	],
	"4.05": [
		{
			"code": "4260",
			"aliq": "2.00",
			"service_description": "Acupuntura"
		}
	],
	"4.06": [
		{
			"code": "4359",
			"aliq": "SUP",
			"service_description": "Enfermagem, inclusive serviços auxiliares (regime especial – sociedade)"
		}
	],
	"4.07": [
		{
			"code": "4383",
			"aliq": "2.00",
			"service_description": "Serviços farmacêuticos"
		}
	],
	"4.08": [
		{
			"code": "4553",
			"aliq": "SUP",
			"service_description": "Terapia ocupacional (regime especial – sociedade)"
		}
	],
	"4.09": [
		{
			"code": "4588",
			"aliq": "2.00",
			"service_description": "Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental, inclusive massoterapia"
		}
	],
	"4.10": [
		{
			"code": "4626",
			"aliq": "2.00",
			"service_description": "Nutrição"
		}
	],
	"4.11": [
		{
			"code": "4677",
			"aliq": "SUP",
			"service_description": "Obstetrícia (regime especial – sociedade)"
		}
	],
	"4.12": [
		{
			"code": "4731",
			"aliq": "SUP",
			"service_description": "Odontologia (regime especial – sociedade)"
		}
	],
	"4.13": [
		{
			"code": "4901",
			"aliq": "SUP",
			"service_description": "Ortóptica (regime especial – sociedade)"
		}
	],
	"4.14": [
		{
			"code": "5096",
			"aliq": "SUP",
			"service_description": "Próteses sob encomenda (regime especial – sociedade)"
		}
	],
	"4.15": [
		{
			"code": "5100",
			"aliq": "2.00",
			"service_description": "Psicanálise"
		}
	],
	"4.16": [
		{
			"code": "5142",
			"aliq": "SUP",
			"service_description": "Psicologia, clínica ou não (regime especial – sociedade)"
		}
	],
	"4.17": [
		{
			"code": "5584",
			"aliq": "2.00",
			"service_description": "Casas de recuperação"
		}
	],
	"4.18": [
		{
			"code": "5193",
			"aliq": "2.00",
			"service_description": "Inseminação artificial, fertilização in vitro e congêneres"
		}
	],
	"4.19": [
		{
			"code": "5223",
			"aliq": "2.00",
			"service_description": "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres"
		}
	],
	"4.20": [
		{
			"code": "5231",
			"aliq": "2.00",
			"service_description": "Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie"
		}
	],
	"4.21": [
		{
			"code": "5266",
			"aliq": "2.00",
			"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres"
		}
	],
	"4.22": [
		{
			"code": "5274",
			"aliq": "2.00",
			"service_description": "Planos de medicina de grupo ou individual e convênios para prestação de assistência médica, hospitalar, odontológica e congêneres"
		}
	],
	"4.23": [
		{
			"code": "5312",
			"aliq": "2.00",
			"service_description": "Outros planos de saúde que se cumpram através de serviços de terceiros contratados, credenciados, cooperados ou apenas pagos pelo operador do plano mediante indicação do beneficiário"
		}
	],
	"5.01": [
		{
			"code": "5410",
			"aliq": "SUP",
			"service_description": "Medicina veterinária e zootecnia (regime especial – sociedade)"
		}
	],
	"5.02": [
		{
			"code": "5428",
			"aliq": "2.00",
			"service_description": "Hospitais, clínicas, ambulatórios, prontos-socorros e congêneres, na área veterinária"
		}
	],
	"5.03": [
		{
			"code": "5436",
			"aliq": "2.00",
			"service_description": "Laboratórios de análise na área veterinária"
		}
	],
	"5.04": [
		{
			"code": "5460",
			"aliq": "2.00",
			"service_description": "Inseminação artificial, fertilização in vitro e congêneres, na área veterinária"
		}
	],
	"5.05": [
		{
			"code": "5479",
			"aliq": "2.00",
			"service_description": "Bancos de sangue e de órgãos e congêneres, na área veterinária"
		}
	],
	"5.06": [
		{
			"code": "5495",
			"aliq": "2.00",
			"service_description": "Coleta de sangue, leite, tecidos, sêmen, órgãos e materiais biológicos de qualquer espécie, na área veterinária"
		}
	],
	"5.07": [
		{
			"code": "5517",
			"aliq": "2.00",
			"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres, na área veterinária"
		}
	],
	"5.08": [
		{
			"code": "8648",
			"aliq": "2.00",
			"service_description": "Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres, relativos a animais"
		}
	],
	"5.09": [
		{
			"code": "5533",
			"aliq": "2.00",
			"service_description": "Planos de atendimento e assistência médico-veterinária"
		}
	],
	"6.01": [
		{
			"code": "8494",
			"aliq": "5.00",
			"service_description": "Barbearia, cabeleireiros, manicuros, pedicuros e congêneres"
		}
	],
	"6.02": [
		{
			"code": "8516",
			"aliq": "5.00",
			"service_description": "Esteticistas, tratamento de pele, depilação e congêneres"
		}
	],
	"6.03": [
		{
			"code": "8532",
			"aliq": "5.00",
			"service_description": "Banhos, duchas, sauna, massagens e congêneres"
		}
	],
	"6.04": [
		{
			"code": "5657",
			"aliq": "2.00",
			"service_description": "Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas"
		}
	],
	"6.05": [
		{
			"code": "8567",
			"aliq": "5.00",
			"service_description": "Centros de emagrecimento, spa e congêneres"
		}
	],
	"6.06": [
		{
			"code": "8658",
			"aliq": "5.00",
			"service_description": "Aplicação de tatuagens, piercings e congêneres"
		}
	],
	"7.01": [
		{
			"code": "1627",
			"aliq": "SUP",
			"service_description": "Agrimensura, geologia e congêneres (regime especial – sociedade)"
		}
	],
	"7.02": [
		{
			"code": "1023",
			"aliq": "5.00",
			"service_description": "Execução por administração, empreitada ou subempreitada, de obras de construção civil, elétrica ou outras obras semelhantes, e respectivos serviços auxiliares ou complementares, inclusive terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos que se agreguem ao imóvel (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)"
		}
	],
	"7.03": [
		{
			"code": "1694",
			"aliq": "5.00",
			"service_description": "Elaboração de planos diretores, estudos de viabilidade, estudos organizacionais e outros, relacionados com obras e serviços de engenharia; elaboração de anteprojetos, projetos básicos e projetos executivos para trabalhos de engenharia"
		}
	],
	"7.04": [
		{
			"code": "1031",
			"aliq": "5.00",
			"service_description": "Demolição"
		}
	],
	"7.05": [
		{
			"code": "1058",
			"aliq": "5.00",
			"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)"
		}
	],
	"7.06": [
		{
			"code": "1228",
			"aliq": "5.00",
			"service_description": "Colocação e instalação de tapetes, carpetes, assoalhos, cortinas, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço"
		}
	],
	"7.07": [
		{
			"code": "1236",
			"aliq": "5.00",
			"service_description": "Recuperação, raspagem, polimento e lustração de pisos e congêneres"
		}
	],
	"7.08": [
		{
			"code": "1244",
			"aliq": "5.00",
			"service_description": "Calafetação"
		}
	],
	"7.09": [
		{
			"code": "1325",
			"aliq": "5.00",
			"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem separação e destinação final de lixo, rejeitos e outros resíduos quaisquer"
		}
	],
	"7.10": [
		{
			"code": "1406",
			"aliq": "2.00",
			"service_description": "Limpeza, manutenção e conservação de imóveis, chaminés, piscinas e congêneres, inclusive fossas"
		}
	],
	"7.11": [
		{
			"code": "1449",
			"aliq": "5.00",
			"service_description": "Jardinagem, inclusive corte e poda de árvores"
		}
	],
	"7.12": [
		{
			"code": "1724",
			"aliq": "5.00",
			"service_description": "Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biológicos"
		}
	],
	"7.13": [
		{
			"code": "1465",
			"aliq": "5.00",
			"service_description": "Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres"
		}
	],
	"7.16": [
		{
			"code": "1740",
			"aliq": "5.00",
			"service_description": "Florestamento, reflorestamento, semeadura, adubação e congêneres"
		}
	],
	"7.17": [
		{
			"code": "1090",
			"aliq": "5.00",
			"service_description": "Escoramento, contenção de encostas e serviços congêneres"
		}
	],
	"7.18": [
		{
			"code": "1473",
			"aliq": "5.00",
			"service_description": "Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres"
		}
	],
	"7.19": [
		{
			"code": "1805",
			"aliq": "5.00",
			"service_description": "Acompanhamento e fiscalização da execução de obras de engenharia, arquitetura e urbanismo"
		}
	],
	"7.20": [
		{
			"code": "1821",
			"aliq": "5.00",
			"service_description": "Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres"
		}
	],
	"7.21": [
		{
			"code": "1864",
			"aliq": "5.00",
			"service_description": "Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais"
		}
	],
	"7.22": [
		{
			"code": "1872",
			"aliq": "5.00",
			"service_description": "Nucleação e bombardeamento de nuvens e congêneres"
		}
	],
	"8.01": [
		{
			"code": "5711",
			"aliq": "5.00",
			"service_description": "Ensino superior, cursos de pós-graduação, mestrado, doutorado, pós-doutorado"
		}
	],
	"8.02": [
		{
			"code": "5762",
			"aliq": "5.00",
			"service_description": "Outros serviços de instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza"
		}
	],
	"9.01": [
		{
			"code": "7099",
			"aliq": "5.00",
			"service_description": "Hospedagem em apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service e congêneres"
		}
	],
	"9.02": [
		{
			"code": "7123",
			"aliq": "2.00",
			"service_description": "Organização, promoção e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres"
		}
	],
	"9.03": [
		{
			"code": "7137",
			"aliq": "5.00",
			"service_description": "Guias de turismo"
		}
	],
	"10.01": [
		{
			"code": "6130",
			"aliq": "2.00",
			"service_description": "Corretagem de seguros"
		}
	],
	"10.02": [
		{
			"code": "6157",
			"aliq": "5.00",
			"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer"
		}
	],
	"10.03": [
		{
			"code": "6173",
			"aliq": "5.00",
			"service_description": "Agenciamento, corretagem ou intermediação de direitos de propriedade industrial (inclusive marcas e patentes), artística ou literária"
		}
	],
	"10.04": [
		{
			"code": "6238",
			"aliq": "5.00",
			"service_description": "Agenciamento, corretagem ou intermediação de contratos de faturização (factoring)"
		}
	],
	"10.05": [
		{
			"code": "6297",
			"aliq": "5.00",
			"service_description": "Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, por quaisquer meios"
		}
	],
	"10.06": [
		{
			"code": "6335",
			"aliq": "5.00",
			"service_description": "Agenciamento marítimo"
		}
	],
	"10.07": [
		{
			"code": "6351",
			"aliq": "5.00",
			"service_description": "Agenciamento de notícias"
		}
	],
	"10.08": [
		{
			"code": "6394",
			"aliq": "5.00",
			"service_description": "Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios"
		}
	],
	"10.09": [
		{
			"code": "6009",
			"aliq": "5.00",
			"service_description": "Representação de qualquer natureza, inclusive comercial"
		}
	],
	"10.10": [
		{
			"code": "6041",
			"aliq": "5.00",
			"service_description": "Distribuição de bens de terceiros"
		}
	],
	"11.01": [
		{
			"code": "7854",
			"aliq": "5.00",
			"service_description": "Guarda e estacionamento de aeronaves e de embarcações"
		}
	],
	"11.02": [
		{
			"code": "7870",
			"aliq": "2.00",
			"service_description": "Vigilância, segurança ou monitoramento de bens e pessoas"
		}
	],
	"11.03": [
		{
			"code": "7897",
			"aliq": "2.00",
			"service_description": "Escolta, inclusive de veículos e cargas"
		}
	],
	"11.04": [
		{
			"code": "7927",
			"aliq": "5.00",
			"service_description": "Armazenamento, depósito, carga, descarga, arrumação e guarda de bens de qualquer espécie"
		}
	],
	"12.01": [
		{
			"code": "8274",
			"aliq": "2.00",
			"service_description": "Espetáculos teatrais e espetáculos circenses, óperas, ballet, danças, concertos, recitais e congêneres (contribuinte não estabelecido no Município de São Paulo)"
		}
	],
	"12.02": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.03": [
		{
			"code": "8274",
			"aliq": "2.00",
			"service_description": "Espetáculos teatrais e espetáculos circenses, óperas, ballet, danças, concertos, recitais e congêneres (contribuinte não estabelecido no Município de São Paulo)"
		}
	],
	"12.04": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.05": [
		{
			"code": "8257",
			"aliq": "2.00",
			"service_description": "Parques de diversões, centros de lazer e congêneres (contribuinte não estabelecido no Município de São Paulo)"
		}
	],
	"12.06": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.07": [
		{
			"code": "8274",
			"aliq": "2.00",
			"service_description": "Espetáculos teatrais e espetáculos circenses, óperas, ballet, danças, concertos, recitais e congêneres (contribuinte não estabelecido no Município de São Paulo)"
		}
	],
	"12.08": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.09": [
		{
			"code": "8397",
			"aliq": "5.00",
			"service_description": "Carteado, dominó, víspora, e outros tipos de diversões com cobrança facultativa de ingresso"
		}
	],
	"12.10": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.11": [
		{
			"code": "8290",
			"aliq": "2.00",
			"service_description": "Competições esportivas – Grande Prêmio Brasil de Fórmula 1. Quando prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.12": [
		{
			"code": "8400",
			"aliq": "5.00",
			"service_description": "Execução de música, individualmente ou por conjunto"
		}
	],
	"12.13": [
		{
			"code": "6777",
			"aliq": "5.00",
			"service_description": "Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres"
		}
	],
	"12.14": [
		{
			"code": "8419",
			"aliq": "5.00",
			"service_description": "Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo"
		}
	],
	"12.15": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.16": [
		{
			"code": "8273",
			"aliq": "5.00",
			"service_description": "Prestação de serviço de Diversões Públicas, prestado por contribuinte não estabelecido no Município de São Paulo"
		}
	],
	"12.17": [
		{
			"code": "7218",
			"aliq": "5.00",
			"service_description": "Recreação e animação, inclusive em festas e eventos de qualquer natureza"
		}
	],
	"13.02": [
		{
			"code": "6793",
			"aliq": "5.00",
			"service_description": "Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres"
		}
	],
	"13.03": [
		{
			"code": "6807",
			"aliq": "5.00",
			"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, retocagem, reprodução, trucagem e congêneres (inclusive para televisão)"
		}
	],
	"13.04": [
		{
			"code": "6940",
			"aliq": "2.00",
			"service_description": "Composição gráfica, inclusive composição de impressos gráficos, fotocomposição, clicheria, zincografia, litografia, fotolitografia, estereotipia, serigrafia e outras matrizes de impressão"
		}
	],
	"13.05": [
		{
			"code": "6912",
			"aliq": "2.00",
			"service_description": "Artes gráficas, tipografia, diagramação, paginação e gravação"
		}
	],
	"14.01": [
		{
			"code": "7510",
			"aliq": "5.00",
			"service_description": "Blindagemimg"
		}
	],
	"14.02": [
		{
			"code": "1880",
			"aliq": "5.00",
			"service_description": "Assistência técnica"
		}
	],
	"14.03": [
		{
			"code": "7552",
			"aliq": "5.00",
			"service_description": "Retífica e recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)"
		}
	],
	"14.04": [
		{
			"code": "7560",
			"aliq": "5.00",
			"service_description": "Recauchutagem ou regeneração de pneus, borracharia"
		}
	],
	"14.05": [
		{
			"code": "7579",
			"aliq": "5.00",
			"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer"
		}
	],
	"14.06": [
		{
			"code": "7315",
			"aliq": "5.00",
			"service_description": "Instalação e montagem industrial, prestada ao usuário final, exclusivamente com material por ele fornecido"
		}
	],
	"14.07": [
		{
			"code": "6831",
			"aliq": "5.00",
			"service_description": "Colocação de molduras e congêneres"
		}
	],
	"14.08": [
		{
			"code": "6858",
			"aliq": "5.00",
			"service_description": "Encadernação, gravação e douração de livros, revistas e congêneres"
		}
	],
	"14.09": [
		{
			"code": "7595",
			"aliq": "5.00",
			"service_description": "Alfaiataria, costura e congêneres, quando o material for fornecido pelo usuário final, exceto aviamento"
		}
	],
	"14.10": [
		{
			"code": "7633",
			"aliq": "5.00",
			"service_description": "Tintureiro individual"
		}
	],
	"14.11": [
		{
			"code": "7641",
			"aliq": "5.00",
			"service_description": "Tapeçaria e reforma de estofamentos em geral"
		}
	],
	"14.12": [
		{
			"code": "7676",
			"aliq": "5.00",
			"service_description": "Funilaria e lanternagem, incluindo a pintura"
		}
	],
	"14.13": [
		{
			"code": "1104",
			"aliq": "5.00",
			"service_description": "Carpintaria e serralheria"
		}
	],
	"14.14": [
		{
			"code": "7324",
			"aliq": "5.00",
			"service_description": "Guincho intramunicipal, guindaste e içamento."
		}
	],
	"15.01": [
		{
			"code": "5837",
			"aliq": "2.00",
			"service_description": "Administração de carteira de cheques pré-datados e congêneres"
		}
	],
	"15.02": [
		{
			"code": "5878",
			"aliq": "5.00",
			"service_description": "Abertura de contas em geral, inclusive conta-corrente, conta de investimentos e aplicação e caderneta de poupança, no País e no exterior, bem como a manutenção das referidas contas ativas e inativas"
		}
	],
	"15.03": [
		{
			"code": "5870",
			"aliq": "5.00",
			"service_description": "Locação e manutenção de cofres particulares, de terminais eletrônicos, de terminais de atendimento e de bens e equipamentos em geral"
		}
	],
	"15.04": [
		{
			"code": "5871",
			"aliq": "5.00",
			"service_description": "Fornecimento ou emissão de atestados em geral, inclusive atestado de idoneidade, atestado de capacidade financeira e congêneres"
		}
	],
	"15.05": [
		{
			"code": "5872",
			"aliq": "5.00",
			"service_description": "Cadastro, elaboração de ficha cadastral, renovação cadastral e congêneres, inclusão ou exclusão no Cadastro de Emitentes de Cheques sem Fundos – CCF ou em quaisquer outros bancos cadastrais"
		}
	],
	"15.06": [
		{
			"code": "5873",
			"aliq": "5.00",
			"service_description": "Emissão, reemissão e fornecimento de avisos, comprovantes e documentos em geral; abono de firmas; coleta e entrega de documentos, bens e valores; comunicação com outra agência ou com a administração central; licenciamento eletrônico de veículos; transferência de veículos; agenciamento fiduciário ou depositário; devolução de bens em custódia"
		}
	],
	"15.07": [
		{
			"code": "5874",
			"aliq": "5.00",
			"service_description": "Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e à rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo"
		}
	],
	"15.08": [
		{
			"code": "5875",
			"aliq": "5.00",
			"service_description": "Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins"
		}
	],
	"15.09": [
		{
			"code": "5851",
			"aliq": "2.00",
			"service_description": "Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing)"
		}
	],
	"15.10": [
		{
			"code": "5877",
			"aliq": "5.00",
			"service_description": "Serviços relacionados a pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; emissão de carnês"
		}
	],
	"15.11": [
		{
			"code": "5879",
			"aliq": "5.00",
			"service_description": "Devolução de títulos, protesto de títulos, sustação de protesto, manutenção de títulos, reapresentação de títulos, e demais serviços a eles relacionados"
		}
	],
	"15.12": [
		{
			"code": "5889",
			"aliq": "5.00",
			"service_description": "Custódia em geral, inclusive de títulos e valores mobiliários"
		}
	],
	"15.13": [
		{
			"code": "5881",
			"aliq": "5.00",
			"service_description": "Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos à carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio"
		}
	],
	"15.14": [
		{
			"code": "5887",
			"aliq": "2.00",
			"service_description": "Fornecimento, emissão, reemissão, renovação e manutenção de cartão magnético, cartão de crédito, cartão de débito, cartão salário e congêneres"
		}
	],
	"15.15": [
		{
			"code": "5891",
			"aliq": "5.00",
			"service_description": "Compensação de cheques e títulos quaisquer; serviços relacionados a depósito, inclusive depósito identificado, a saque de contas quaisquer, por qualquer meio ou processo, inclusive em terminais eletrônicos e de atendimento"
		}
	],
	"15.16": [
		{
			"code": "5893",
			"aliq": "5.00",
			"service_description": "Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo; serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral"
		}
	],
	"15.17": [
		{
			"code": "5885",
			"aliq": "5.00",
			"service_description": "Emissão, fornecimento, devolução, sustação, cancelamento e oposição de cheques quaisquer, avulso ou por talão"
		}
	],
	"15.18": [
		{
			"code": "5886",
			"aliq": "5.00",
			"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário"
		}
	],
	"16.01": [
		{
			"code": "2447",
			"aliq": "5.00",
			"service_description": "Transporte de bens ou valores, dentro do território do Município (inclusive trans- porte de veículos)."
		}
	],
	"17.01": [
		{
			"code": "3115",
			"aliq": "5.00",
			"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista"
		}
	],
	"17.02": [
		{
			"code": "3158",
			"aliq": "5.00",
			"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível (telemarketing), redação, edição, revisão, apoio e infra-estrutura administrativa e congêneres"
		}
	],
	"17.03": [
		{
			"code": "1899",
			"aliq": "5.00",
			"service_description": "Planejamento, coordenação, programação ou organização técnica, financeira ou administrativa"
		}
	],
	"17.04": [
		{
			"code": "6475",
			"aliq": "5.00",
			"service_description": "Recrutamento, agenciamento, seleção e colocação de mão-de-obra"
		}
	],
	"17.05": [
		{
			"code": "6491",
			"aliq": "2.00",
			"service_description": "Fornecimento de mão-de-obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço"
		}
	],
	"17.06": [
		{
			"code": "2496",
			"aliq": "5.00",
			"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários"
		}
	],
	"17.08": [
		{
			"code": "6521",
			"aliq": "5.00",
			"service_description": "Franquia (franchising)"
		}
	],
	"17.09": [
		{
			"code": "1902",
			"aliq": "5.00",
			"service_description": "Perícias, laudos, exames técnicos e análises técnicas, inclusive institutos psicotécnicos"
		}
	],
	"17.10": [
		{
			"code": "7161",
			"aliq": "2.00",
			"service_description": "Planejamento, organização e administração de feiras, exposições, congressos e congêneres"
		}
	],
	"17.11": [
		{
			"code": "3210",
			"aliq": "2.00",
			"service_description": "Administração de benefícios relativos a planos de assistência à saúde."
		}
	],
	"17.12": [
		{
			"code": "5894",
			"aliq": "5.00",
			"service_description": "Administração de distribuição de co-seguros"
		}
	],
	"17.13": [
		{
			"code": "6530",
			"aliq": "5.00",
			"service_description": "Leilão e congêneres"
		}
	],
	"17.14": [
		{
			"code": "3379",
			"aliq": "SUP",
			"service_description": "Advocacia (regime especial – sociedade)"
		}
	],
	"17.15": [
		{
			"code": "3387",
			"aliq": "5.00",
			"service_description": "Arbitragem de qualquer espécie, inclusive jurídica"
		}
	],
	"17.16": [
		{
			"code": "3433",
			"aliq": "SUP",
			"service_description": "Auditoria (regime especial – sociedade)"
		}
	],
	"17.17": [
		{
			"code": "2038",
			"aliq": "5.00",
			"service_description": "Análise de organização e métodos"
		}
	],
	"17.18": [
		{
			"code": "3450",
			"aliq": "5.00",
			"service_description": "Atuária e cálculos técnicos de qualquer natureza"
		}
	],
	"17.19": [
		{
			"code": "3620",
			"aliq": "SUP",
			"service_description": "Contador, técnico em contabilidade, guarda-livros e congêneres (regime especial – sociedade)"
		}
	],
	"17.20": [
		{
			"code": "3700",
			"aliq": "SUP",
			"service_description": "Economistas (regime especial – sociedade)"
		}
	],
	"17.21": [
		{
			"code": "3719",
			"aliq": "5.00",
			"service_description": "Estatística"
		}
	],
	"17.22": [
		{
			"code": "6564",
			"aliq": "5.00",
			"service_description": "Cobranças e recebimentos por conta de terceiros, protestos de títulos, sustação de protestos, devolução de títulos não pagos, manutenção de títulos vencidos, fornecimentos de posição de cobrança ou recebimento e outros serviços correlatos (exceto serviços de instituições financeiras)"
		}
	],
	"17.23": [
		{
			"code": "3743",
			"aliq": "5.00",
			"service_description": "Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring)"
		}
	],
	"17.24": [
		{
			"code": "2498",
			"aliq": "2.90",
			"service_description": "Inserção de textos, desenhos e outros materiais de propaganda e publicidade, em qualquer meio (exceto em livros, jornais, periódicos e nas modalidades de serviços de radiodifusão sonora e de sons e imagens de recepção livre e gratuita)"
		}
	],
	"18.01": [
		{
			"code": "5916",
			"aliq": "5.00",
			"service_description": "Serviços de regulação de sinistros vinculados a contratos de seguros; inspeção e avaliação de riscos para cobertura de contratos de seguros; prevenção e gerência de riscos seguráveis e congêneres"
		}
	],
	"19.01": [
		{
			"code": "8486",
			"aliq": "5.00",
			"service_description": "Serviços de distribuição e venda de bilhetes e demais produtos de loteria, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres"
		}
	],
	"20.01": [
		{
			"code": "7951",
			"aliq": "5.00",
			"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres"
		}
	],
	"20.02": [
		{
			"code": "7960",
			"aliq": "5.00",
			"service_description": "Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres"
		}
	],
	"20.03": [
		{
			"code": "7978",
			"aliq": "5.00",
			"service_description": "Serviços de terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações, logística e congêneres"
		}
	],
	"21.01": [
		{
			"code": "3875",
			"aliq": "5.00",
			"service_description": "Serviços de registros públicos, cartorários e notariais"
		}
	],
	"22.01": [
		{
			"code": "1481",
			"aliq": "5.00",
			"service_description": "Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, manutenção, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais"
		}
	],
	"23.01": [
		{
			"code": "2500",
			"aliq": "5.00",
			"service_description": "Serviços de programação visual, comunicação visual e congêneres"
		}
	],
	"24.01": [
		{
			"code": "6963",
			"aliq": "5.00",
			"service_description": "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres"
		}
	],
	"25.01": [
		{
			"code": "6572",
			"aliq": "5.00",
			"service_description": "Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres"
		}
	],
	"25.02": [
		{
			"code": "6581",
			"aliq": "5.00",
			"service_description": "Traslado intramunicipal de corpos e partes de corpos cadavéricos"
		}
	],
	"25.03": [
		{
			"code": "6602",
			"aliq": "5.00",
			"service_description": "Planos ou convênio funerários"
		}
	],
	"25.04": [
		{
			"code": "6610",
			"aliq": "5.00",
			"service_description": "Manutenção e conservação de jazigos e cemitérios"
		}
	],
	"25.05": [
		{
			"code": "6613",
			"aliq": "5.00",
			"service_description": "Cessão de uso de espaços em cemitérios para sepultamento"
		}
	],
	"26.01": [
		{
			"code": "2461",
			"aliq": "5.00",
			"service_description": "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, realizados inclusive por courrier e congêneres"
		}
	],
	"27.01": [
		{
			"code": "2097",
			"aliq": "5.00",
			"service_description": "Serviços de assistência social"
		}
	],
	"28.01": [
		{
			"code": "2119",
			"aliq": "5.00",
			"service_description": "Serviços de avaliação de bens e serviços de qualquer natureza"
		}
	],
	"29.01": [
		{
			"code": "3956",
			"aliq": "5.00",
			"service_description": "Serviços de biblioteconomia"
		}
	],
	"30.01": [
		{
			"code": "2143",
			"aliq": "5.00",
			"service_description": "Serviços de biologia, biotecnologia e química"
		}
	],
	"31.01": [
		{
			"code": "2151",
			"aliq": "5.00",
			"service_description": "Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres"
		}
	],
	"32.01": [
		{
			"code": "2186",
			"aliq": "5.00",
			"service_description": "Serviços de desenhos técnicos"
		}
	],
	"33.01": [
		{
			"code": "6637",
			"aliq": "5.00",
			"service_description": "Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres"
		}
	],
	"34.01": [
		{
			"code": "8672",
			"aliq": "5.00",
			"service_description": "Serviços de investigações particulares, detetives e congêneres"
		}
	],
	"35.01": [
		{
			"code": "2534",
			"aliq": "5.00",
			"service_description": "Serviços de reportagem, assessoria de imprensa, jornalismo e relações públicas"
		}
	],
	"36.01": [
		{
			"code": "2216",
			"aliq": "5.00",
			"service_description": "Serviços de meteorologia"
		}
	],
	"37.01": [
		{
			"code": "8842",
			"aliq": "5.00",
			"service_description": "Serviços de artistas, atletas, modelos e manequins"
		}
	],
	"38.01": [
		{
			"code": "2224",
			"aliq": "5.00",
			"service_description": "Serviços de museologia"
		}
	],
	"39.01": [
		{
			"code": "8885",
			"aliq": "5.00",
			"service_description": "Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)"
		}
	],
	"40.01": [
		{
			"code": "8893",
			"aliq": "5.00",
			"service_description": "Serviços relativos a obras de arte sob encomenda"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/views/Fiscal/NFSe/emit/utils/item_code_services.json
// module id = 621
// module chunks = 0